import { render, staticRenderFns } from "./HTML.vue?vue&type=template&id=0b588988&scoped=true&"
import script from "./HTML.vue?vue&type=script&lang=js&"
export * from "./HTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b588988",
  null
  
)

export default component.exports